import React, { Component } from 'react';
import { Badge, Card, CardBody, Col, Row } from "reactstrap";
import { airlines } from "../../redux/utils/airlines";
import { airports } from "../../redux/utils/airports";
import * as moment from 'moment';
import 'moment-timezone';
import connect from "react-redux/es/connect/connect";
import { setTicket } from "../../redux/actions/ticket";

class FlightReviewDetails extends Component {
    constructor(props) {
        super(props);

        /********ART */
        const { data, adultNo, childNo, infantNo } = this.props;
        moment.defaultFormat = "DD MMM YYYY HH:mm:ss";

        let leaveOptions = data.airItinerary.leaveOptions[0];
        let flightSegments = leaveOptions.flightSegments[0];
        //arival
        let arrivalAirport = airports.filter(item => item.iata === flightSegments.arrivalAirport.code)[0];
        let arrivalDate = moment(flightSegments.arrivalDate, moment.defaultFormat).format('dd DD MMM');//19 Jan 2019 23:19:00
        let arrivalTime = moment(flightSegments.arrivalDate, moment.defaultFormat).format('HH:mm');
        //departure
        let departureAirport = airports.filter(item => item.iata === flightSegments.departureAirport.code)[0];
        let departureTime = moment(flightSegments.departureDate, moment.defaultFormat).format('HH:mm');

        let flightNumber = flightSegments.flightNumber;
        let airLine = {
            "name": "unknown",
            "iata": flightSegments.marketingAirLine.code,
            "icon": "airline/icon.png",
        };

        let airlineByFilter = airlines.filter(item => item.iata === flightSegments.marketingAirLine.code);
        if (airlineByFilter.length > 0) {
            airLine = airlineByFilter[0];
        }
        let bookingClassAvail = flightSegments.bookingClassAvail;
        let equipment = flightSegments.equipment;
        let isChartered = leaveOptions.isChartered;

        let resBookDesigQuantity = leaveOptions.resBookDesigQuantity;
        let price = data.airItineraryPricingInfo;

        let adultFare = 0;
        let adultFareT = 0;
        let childFare = 0;
        let childFareT = 0;
        let infantFare = 0;
        let infantFareT = 0;
        price.ptcFareBreakdowns.map(it => {
            let item = it.passengerFares[0];
            if (item.passengerTypeQuantity.passengerType === "Adult") {
                adultFare = item.baseFare.amount;
                adultFareT = item.totalFare.amount;
            } else if (item.passengerTypeQuantity.passengerType === "Child") {
                childFare = item.baseFare.amount;
                childFareT = item.totalFare.amount;
            } else {
                infantFare = item.baseFare.amount;
                infantFareT = item.totalFare.amount;
            }
            return null;
        });
        let ticket = {
            isDomestic: data.isDomestic,
            departureAirport: flightSegments.departureAirport.code,
            arrivalAirport: flightSegments.arrivalAirport.code,
            departureDate: flightSegments.departureDate,
            arrivalDate: flightSegments.arrivalDate,
            airLine: flightSegments.marketingAirLine.code,
            bookingClassAvail: bookingClassAvail.cabinType,
            airEquipType: equipment.airEquipType,
            airEquipName: equipment.name,
            flightNumber: flightNumber,
            flightDuration: flightSegments.flightDuration,
            isChartered: isChartered,
            isRefundable: leaveOptions.isRefundable,
            availableSeat: resBookDesigQuantity,
            airItineraryRph: data.airItinerary.airItineraryRph,
            baseFare: price.itinTotalFare.baseFare.amount,
            totalFare: price.itinTotalFare.totalFare.amount,
            adultFare,
            adultFareT,
            childFare,
            childFareT,
            infantFare,
            infantFareT,
        };
        let totalPrice = parseInt(adultNo, 10) * parseFloat(adultFareT) +
            parseInt(childNo, 10) * parseFloat(childFareT) +
            parseInt(infantNo, 10) * parseFloat(infantFareT);

        /********ART */


        this.state = {
            loading: false,

            adultNo: adultNo,
            childNo: childNo,
            infantNo: infantNo,
            orgTicket: data,
            ticket: ticket,

            redirect: false,
            departureAirport: departureAirport,
            arrivalAirport: arrivalAirport,
            arrivalDate: arrivalDate,
            arrivalTime: arrivalTime,
            departureTime: departureTime,
            airLine: airLine,
            totalPrice: totalPrice
        };
    }

    render() {

        return (
            <Card className="white mb-3 w-100 flight-item ticket-pasenger-ticket">
                <CardBody>
                    <Row>
                        <Col md={9}>
                            <Row>
                                <div className='ticket-body'>
                                    <div className='ticket-image'>
                                        <img src={`./../../assets/images/${this.state.airLine.icon}`} alt={this.state.airLine.name}
                                            className='ticket-logo' />
                                        <p className="d-none d-md-block d-lg-block company-title">{this.state.airLine.name}</p>
                                    </div>
                                    <div className='ticket-from'>
                                        <p><i className='fa fa-clock-o ' />{' ' + this.state.departureTime} </p>
                                        <p><i className='fa fa-map-marker' /> {this.state.departureAirport.city} </p>
                                        <p className="d-none d-md-block d-lg-block">
                                            {/* <i className='fa fa-plane' /> */}
                                            {this.state.departureAirport.name} </p>

                                    </div>
                                    <div className='ticket-arrow'>
                                        <p className='ticket-date'>{this.state.arrivalDate}</p>
                                        <div className="arrow">
                                            <img className='start-piont-img' src='/assets/images/plane.png' alt='small-plane' />
                                            <span className="arrow-width" />
                                            <i className='end-point' ></i>
                                        </div>
                                    </div>
                                    <div className='ticket-to'>
                                        <p><i className='fa fa-clock-o ' />{this.state.arrivalTime}</p>
                                        <p><i className='fa fa-map-marker' /> {this.state.arrivalAirport.city} </p>
                                        <p className="d-none d-md-block d-lg-block">
                                            {/* <i className='fa fa-plane' /> */}
                                            {this.state.arrivalAirport.name}  </p>
                                    </div>
                                </div>
                            </Row>
                            <Row className="d-none d-md-block d-lg-block">
                                <div className='flight-features'>
                                    <div className='flight-no'><span>Flight no:</span> {this.state.ticket.flightNumber}</div>
                                    {(this.state.ticket.airEquipType === "-1") ? "" :
                                        <div className='plane-type'>{this.state.ticket.airEquipName}</div>
                                    }
                                    <div className='flight-class'>{this.state.ticket.bookingClassAvail}</div>
                                    <div className='flight-type'>{this.state.ticket.isChartered ?
                                        <Badge color="danger">Charter</Badge> :
                                        <Badge color="primary">Standard</Badge>
                                    }</div>
                                </div>
                            </Row>

                        </Col>
                        <Col md={3} className='text-center ticket-price'>
                            <p>Adult: {this.state.adultNo}
                            </p>
                            {(this.state.childNo === 0) ? null :
                                <p>Child: {this.state.childNo}
                                </p>}
                            {(this.state.infantNo === 0) ? null :
                                <p>Infant: {this.state.infantNo}
                                </p>}
                            <hr />

                        </Col>
                    </Row>

                </CardBody>
            </Card>
        );
    }
    handleClick() {


    }
    calculateData() {

    }
}
const mapDispatchToProps = dispatch => {
    return {
        setTicket: (orgTicket, ticket, adultNo, childNo, infantNo) => {
            dispatch(setTicket(orgTicket, ticket, adultNo, childNo, infantNo))
        }
    }
};

const mapStateToProps = (state) => {
    return {
        user: state.user,
    }
};
export default connect(mapStateToProps, mapDispatchToProps)(FlightReviewDetails)


// WEBPACK FOOTER //
// ./src/components/review/FlightreviewDetail.jsx